"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Wrapper = exports.MOBILE_HEADER_HEIGHT = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var MOBILE_ARROW_SIZE = 24;
exports.MOBILE_HEADER_HEIGHT = 44;
var MOBILE_LOGO_HEIGHT = 30;
exports.Wrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  border-bottom: 1px solid ", ";\n  height: ", "px;\n  position: relative;\n\n  .NavBar__backButton {\n    cursor: pointer;\n    left: ", ";\n    position: absolute;\n    top: ", "px;\n  }\n\n  .NavBar__backArrow,\n  .NavBar__backButton {\n    height: ", "px;\n    width: ", "px;\n  }\n\n  .NavBar__logoWrapper {\n    height: ", "px;\n    margin: 0 auto;\n    padding: ", "px 0px;\n    width: 50%;\n  }\n"], ["\n  background-color: ", ";\n  border-bottom: 1px solid ", ";\n  height: ", "px;\n  position: relative;\n\n  .NavBar__backButton {\n    cursor: pointer;\n    left: ", ";\n    position: absolute;\n    top: ", "px;\n  }\n\n  .NavBar__backArrow,\n  .NavBar__backButton {\n    height: ", "px;\n    width: ", "px;\n  }\n\n  .NavBar__logoWrapper {\n    height: ", "px;\n    margin: 0 auto;\n    padding: ", "px 0px;\n    width: 50%;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.white.s100;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.gray.s300;
}, exports.MOBILE_HEADER_HEIGHT, function (_a) {
    var theme = _a.theme;
    return theme.space.s200;
}, (exports.MOBILE_HEADER_HEIGHT - MOBILE_ARROW_SIZE) / 2, MOBILE_ARROW_SIZE, MOBILE_ARROW_SIZE, MOBILE_LOGO_HEIGHT, (exports.MOBILE_HEADER_HEIGHT - MOBILE_LOGO_HEIGHT) / 2);
exports.Wrapper.displayName = 'NavBarWrapper';
var templateObject_1;
